module.exports = __webpack_public_path__ + "img/nikshay_headerIcon.381cb551.svg";